const INITIAL_STATE = {
  data: [],
  categorySelectedName: '',
  servicesSelected: [],
};

// REQUEST -> SAGA -> CHAMADA API -> REDUCER -> SUCCESS

/**
 * Types
 */
export const Types = {
  GET_SERVICES_SUCCESS: 'services/GET_SERVICES_SUCCESS',
  GET_SERVICES_BY_CITY_REQUEST: 'services/GET_SERVICES_BY_CITY_RESQUEST',
  GET_SERVICES_BY_CITY_SUCCESS: 'services/GET_SERVICES_BY_CITY_SUCCESS',
  GET_SERVICES_BY_CATEGORY_REQUEST: 'services/GET_SERVICES_BY_CATEGORY_REQUEST',
  GET_SERVICES_BY_CATEGORY_SUCCESS: 'services/GET_SERVICES_BY_CATEGORY_SUCCESS',
  SET_CATEGORY_SELECTED: 'services/SET_CATEGORY_SELECTED',
};

/**
 * Reducer
 */
export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_SERVICES_SUCCESS:
      return { ...state, data: action.payload };
    case Types.GET_SERVICES_BY_CITY_SUCCESS:
      return { ...state, data: action.payload };
    case Types.GET_SERVICES_BY_CATEGORY_SUCCESS:
      return { ...state, servicesSelected: action.payload };
    case Types.SET_CATEGORY_SELECTED:
      return { ...state, categorySelectedName: action.payload };
    default:
      return state;
  }
}

/**
 * Helpers
 */
// eslint-disable-next-line max-len
// export const isUserAuth = triiderUser => !!(triiderUser && triiderUser.token && triiderUser.user && triiderUser.user.id);

/**
 * Actions Creators
 */
export const Creators = {
  getServicesSuccess: payload => ({
    type: Types.GET_SERVICES_SUCCESS,
    payload,
  }),
  getServicesByCitySuccess: payload => ({
    type: Types.GET_SERVICES_BY_CITY_SUCCESS,
    payload,
  }),
  getServicesByCityRequest: payload => ({
    type: Types.GET_SERVICES_BY_CITY_REQUEST,
    payload,
  }),
  getServiceByCategoryRequest: (categoryId, city_id) => ({
    type: Types.GET_SERVICES_BY_CATEGORY_REQUEST,
    payload: { categoryId, city_id },
  }),
  getServiceByCategorySuccess: payload => ({
    type: Types.GET_SERVICES_BY_CATEGORY_SUCCESS,
    payload,
  }),
  setCategorySelected: payload => ({
    type: Types.SET_CATEGORY_SELECTED,
    payload,
  }),
};
